import { SvgIcon, type SvgIconProps } from './svgIcon'

export const RequestQuoteIcon = ({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 16 20" {...props}>
    <path
      d="M7.42308 16.625H8.92305V15.625H10.923V11.125H6.92305V9.62495H10.923V8.12498H8.92305V7.12498H7.42308V8.12498H5.42308V12.625H9.42308V14.125H5.42308V15.625H7.42308V16.625ZM0.5 19.5V0.5H10.8653L15.5 5.1346V19.5H0.5ZM1.99997 18H14V5.88458H10.1154V1.99998H1.99997V18Z"
      fill="currentColor"
    />
  </SvgIcon>
)
